export default __webpack_public_path__ + "static/media/import.1b854caf.svg";